module.exports.Event = globalThis.Event;
module.exports.EventTarget = globalThis.EventTarget;
module.exports.CustomEvent = globalThis.CustomEvent;